'use client';
import Script from 'next/script';

interface GoogleTagProps {
  /** GA4 (`G-…`) and Google Ads (`AW-…`) IDs, all served by one gtag.js. */
  ids: string[];
  needConsent?: boolean;
}

/**
 * The consent default has to be queued before any `config`, so it is read
 * straight from the cookie here - the consent hook may run before or after
 * this script and only updates what is already in place.
 */
const consentDefault = `
  var consentGranted = document.cookie.split('; ').indexOf('cookie-consent=true') !== -1;
  var consentStatus = consentGranted ? 'granted' : 'denied';
  gtag('consent', 'default', {
    analytics_storage: 'granted',
    ad_storage: 'granted',
    ad_user_data: 'granted',
    ad_personalization: 'granted',
  });

  // OVERRIDE with 'denied' ONLY for EEA + UK regions 
  gtag('consent', 'default', {
    analytics_storage: consentGranted ? 'granted' : 'denied',
    ad_storage: consentGranted ? 'granted' : 'denied',
    ad_user_data: consentGranted ? 'granted' : 'denied',
    ad_personalization: consentGranted ? 'granted' : 'denied',
    region: ['AT', 'BE', 'BG', 'HR', 'CY', 'CZ', 'DK', 'EE', 'FI', 'FR', 'DE', 'GR', 'HU', 'IE', 'IT', 'LV', 'LT', 'LU', 'MT', 'NL', 'PL', 'PT', 'RO', 'SK', 'SI', 'ES', 'SE', 'IS', 'LI', 'NO', 'CH', 'GB']
  });
`;

const GoogleTag = ({ ids, needConsent }: GoogleTagProps) => (
  <>
    <Script id="google-tag-init" strategy="afterInteractive">
      {`
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        ${needConsent ? consentDefault : ''}
        gtag('js', new Date());
        ${ids.map((id) => `gtag('config', '${id}');`).join('\n')}
      `}
    </Script>
    <Script
      id="google-tag"
      strategy="afterInteractive"
      src={`https://www.googletagmanager.com/gtag/js?id=${ids[0]}`}
    />
  </>
);

export default GoogleTag;
